import React, { useState, useEffect } from 'react'

import styled from 'styled-components';

import MapComponent from '../components/home/GoogleMaps/MapComponent'
import MapFilter from '../components/home/GoogleMaps/MapFilter'
import { getDeviceMap } from '../api/getDevicesMap';
/*
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
*/


function MapPage({
  theme
}) {
  const user = JSON.parse(localStorage.getItem("user"));
  const [devicesData, setDevicesData] = useState([]);
  const [filter, setFilter] = useState({});

  const filteredDevices = devicesData?.filter(device => {
    switch (filter) {
      case "actives":
        return device.status === 2;

      case "alerts":
        return device.status === 1;

      case "inactives":
        return device.status === 0;

      default:
        return true;
    }
  });
  useEffect(()=>{
    try{
      init(user.token, user.id, setDevicesData)
    }catch(e){
      console.log('Error: ', e)
    }
    
    
  }, [user?.id, user?.token])

  return (
    <Container>
      <MapFilter cleanFilter={false} setFilter={setFilter}/>
      <div className='MapContainer'>
        <MapComponent theme={theme} devices={filteredDevices} />
      </div>
    </Container>
  )
}


async function init(token, id, setDevices){
  try{
    const response = await getDeviceMap(id, token)
    if(response.error){
      console.log('Error: ', response.message || response.status_code || "Unknown error");
      if(response.status_code === 401){
        localStorage.removeItem("user");
        window.location.href = "/login";
      }
      return;
    }
    const data = response.data;
    //Obtener estado de dispositivos
    let devices = [];
    for(const device of data.data){
      if(!device.client_info) continue;
      const client_info = JSON.parse(device.client_info);
      //console.log(client_info)
      devices.push({
        id: device?.id,
        hwid: device?.hwid,
        name: device?.name,
        lat: client_info?.long,
        lng: client_info?.lat,
        status: device?.status
      })
    }
    //console.log(devices)
    //Setear valores
    setDevices(devices)
    


  }catch(e){
    console.log('Error: ', e)
  }
}


//#region styles
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 2%;
  width: 100%;
  .MapContainer{
    background: transparent;
    overflow: hidden;
    border-radius: 8px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, .3);
    height: 80vh;
    width: 100%;
  }
`;

//#endregion

export default MapPage